// extracted by mini-css-extract-plugin
export default {"onWaitlistPage":"OnWaitlistPage_onWaitlistPage__T+lfI","genericStateBlock":"OnWaitlistPage_genericStateBlock__r0fAC"};